// extracted by mini-css-extract-plugin
module.exports = {"container":"TabMenu_container__Hay3j"};